import { WarehousesI } from '../interfaces/warehouses.interface'
import { WarehousesService } from '../services/warehouses.service'
import {
    GetWarehousesParams,
    WarehousesGetByCityIdResponseT,
    WarehousesGetListResponseT,
} from '../types/warehouses.types'

const warehousesService = new WarehousesService()

class WarehousesRealisation implements WarehousesI {
    getWarehouse(city_id: number): Promise<WarehousesGetByCityIdResponseT> {
        return warehousesService.getWarehouse(city_id)
    }

    async getWarehouses(params?: GetWarehousesParams): Promise<WarehousesGetListResponseT> {
        return warehousesService.getWarehouses(params)
    }
}

export const warehouses = new WarehousesRealisation()
